function Video() {
    return (
        <div className="aProposVideo">
            <iframe width="600" height="400" src="https://www.youtube.com/embed/ncSmpfx3MDg?si=HvPqnDJWFXWdgHx1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            
        </div>
    )
}

export default Video;